import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Link from 'components/shared/link';

import appStoreIcon from './svg/app-store.svg';
import googlePlayIcon from './svg/google-play.svg';

import styles from './app-button.module.scss';

const iconsCollection = {
  appStore: appStoreIcon,
  googlePlay: googlePlayIcon,
};

const texts = {
  appStore: 'App Store',
  googlePlay: 'Google Play',
};

const cx = classNames.bind(styles);

const AppButton = ({ className: additionalClassName = null, type, href, disabled = false }) => {
  const icon = iconsCollection[type];
  const text = texts[type];

  const className = cx('wrapper', type, { disabled }, additionalClassName);

  return (
    <Link className={className} to={href} target="_blank" rel="noopener noreferrer">
      <img src={icon} alt={text} className={cx('icon')} loading="lazy" height={70} width={210} />
    </Link>
  );
};

AppButton.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['appStore', 'googlePlay']).isRequired,
  href: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default AppButton;
